import { FC } from 'react'

import { useForm, useStore } from '@tanstack/react-form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { Dialog, DialogFace, DialogFooterActions, FF, LeaveConfirmation, TextareaInput, Toast } from 'ui/components'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'
import { FormContentWrapper } from 'ui/temp/Dialogs/FormContentWrapper'
import { DialogCol, FormRow } from 'ui/themes/globalStyles'

import { handlerServerError } from '@orbit/errors'

import { HRR_DETAILS_KEY } from '../../../../../../query'
import { SendTaskDialogProps } from './SendTaskDialogProps'

export const SendTaskDialog: FC<SendTaskDialogProps> = (props) => {
  const { licenseId, customAnalyticsId, onClose } = props
  const queryClient = useQueryClient()
  const confirmation = useConfirmation()

  const { mutate, isPending } = useMutation<
    void,
    Error,
    { customAnalyticsId: number; licenseId: number; notes: string }
  >({
    mutationFn: (opts) => Request.post(Request.urls.bank.salesDataClientSourceTaskSending, opts),
    onSuccess: () => {
      Toast.successSmall('Notes have been saved.')
      queryClient.invalidateQueries({ queryKey: [HRR_DETAILS_KEY] })
      onClose()
    },
    onError: (error) => handlerServerError(error)
  })

  const handleTaskSend = async () => {
    await confirmation.showAskConfirmation({
      message: `Are you sure you want to Send Task?`,
      submitButtonText: 'Send Task',
      confirmCallback: async () =>
        mutate({
          licenseId: licenseId,
          customAnalyticsId: customAnalyticsId,
          notes: formApi.store.state.values.notes
        })
    })
  }

  const formApi = useForm({
    defaultValues: { notes: '' },
    onSubmit: handleTaskSend
  })

  const isDirty = useStore(formApi.store, (s) => s.isDirty)

  return (
    <LeaveConfirmation preventLeaving={isDirty && !isPending}>
      <Dialog
        id="send-task"
        title="Send Task"
        face={DialogFace.PRIMARY}
        footerActions={[DialogFooterActions.SUBMIT, DialogFooterActions.CANCEL]}
        isSubmitting={isPending}
        onClose={onClose}
        onSubmit={handleTaskSend}
      >
        <FormContentWrapper>
          <FormRow>
            <DialogCol>
              <formApi.Field
                name="notes"
                children={(filesField) => (
                  <FF field={filesField} label="Notes" input={(inputProps) => <TextareaInput {...inputProps} />} />
                )}
              />
            </DialogCol>
          </FormRow>
        </FormContentWrapper>
      </Dialog>
    </LeaveConfirmation>
  )
}
